import React, { Component } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormGroup,
  CInput,
  CLabel,
  CRow,
  CSelect,
  CTextarea
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";

import bgConclusao from "../../assets/certificates/bg-conclusao.png";
import bgDestaque from "../../assets/certificates/bg-destaque.png";
import bgExcelencia from "../../assets/certificates/bg-excelencia.png";
import bgOutro from "../../assets/certificates/bg-outro.png";
import bgParticipacao from "../../assets/certificates/bg-participacao.png";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";
import "./certificates.css";

const OTHER_TYPE = "outro";

const TYPE_OPTIONS = [
  { value: "participacao", label: "Participação" },
  { value: "conclusao", label: "Conclusão" },
  { value: "destaque", label: "Destaque/Mérito" },
  { value: "excelencia", label: "Excelência" },
  { value: OTHER_TYPE, label: "Outro" }
];

const FIXED_TITLES = {
  participacao: "Certificado de Participação",
  conclusao: "Certificado de Conclusão",
  destaque: "Certificado de Destaque",
  excelencia: "Certificado de Excelência Acadêmica"
};

const BACKGROUND_IMAGES = {
  participacao: bgParticipacao,
  conclusao: bgConclusao,
  destaque: bgDestaque,
  excelencia: bgExcelencia,
  outro: bgOutro
};

const escapeHtml = htmlStr =>
  String(htmlStr)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

class CommunityContentCertificates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      students: [],
      certificates: [],
      type: "",
      customTitle: "",
      message: "",
      studentUserId: ""
    };
  }

  componentDidMount() {
    this.fetchStudents();
    this.fetchCertificates();
  }

  fetchStudents() {
    axios
      .post(
        `${URL.api}community/room_user/listPaginate?page=1&offset=1000`,
        { room: this.props.match.params },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        const students = resp.data.data.users.filter(
          user => !user.administrator
        );
        this.setState({ students, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
        toastr.error("Erro", "Não foi possível carregar os alunos da turma.");
      });
  }

  fetchCertificates() {
    const { id } = this.props.match.params;

    axios
      .get(`${URL.api}gamification/certificates`, {
        params: { room_id: id },
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ certificates: resp.data.data });
      })
      .catch(() => {
        toastr.error(
          "Erro",
          "Não foi possível carregar o histórico de certificados."
        );
      });
  }

  getResolvedTitle() {
    return this.state.type === OTHER_TYPE
      ? this.state.customTitle.trim()
      : FIXED_TITLES[this.state.type] || "";
  }

  canIssue() {
    return Boolean(
      this.state.type && this.getResolvedTitle() && this.state.studentUserId
    );
  }

  handleIssue = () => {
    const { id } = this.props.match.params;

    axios
      .post(
        `${URL.api}gamification/certificates`,
        {
          room_id: id,
          student_user_id: this.state.studentUserId,
          type: this.state.type,
          title: this.getResolvedTitle(),
          message: this.state.message.trim() || null
        },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        if (resp.data.success) {
          this.setState(state => ({
            certificates: [resp.data.data, ...state.certificates],
            type: "",
            customTitle: "",
            message: "",
            studentUserId: ""
          }));
          this.printCertificate(resp.data.data);
        }
      })
      .catch(error => {
        toastr.error(
          "Erro",
          error.response?.data?.error ||
            "Não foi possível emitir o certificado."
        );
      });
  };

  printCertificate(certificate) {
    const myWindow = window.open("", "Certificado");
    const issuedDate = new Date(certificate.issued_at).toLocaleDateString(
      "pt-br",
      { year: "numeric", month: "long", day: "numeric" }
    );
    const schoolName = certificate.school_name
      ? escapeHtml(certificate.school_name)
      : "";
    const studentName = escapeHtml(certificate.student_name);
    const title = escapeHtml(certificate.title);
    const roomName = escapeHtml(certificate.room_name);
    const issuerName = escapeHtml(certificate.issuer_name);
    const message = certificate.message ? escapeHtml(certificate.message) : "";
    const backgroundImage =
      BACKGROUND_IMAGES[certificate.type] || BACKGROUND_IMAGES[OTHER_TYPE];
    const fileName = escapeHtml(
      `certificado_${certificate.type}_${certificate.student_name.replace(
        /\s+/g,
        "_"
      )}`
    );

    myWindow.document.write(`
      <!DOCTYPE html>
      <html lang="pt">
        <head>
          <meta charset="UTF-8">
          <title>${fileName}</title>
          <style>
            @page { size: 297mm 210mm; margin: 0; }
            html, body {
              margin: 0;
              padding: 0;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            .frame {
              width: 297mm;
              height: 210mm;
              background-image: url('${backgroundImage}');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              box-sizing: border-box;
              padding: 22mm 38mm 48mm;
              text-align: center;
              font-family: Georgia, serif;
              color: #333;
              display: flex;
              flex-direction: column;
              justify-content: center;
            }
            .institution { font-size: 12px; text-transform: uppercase; letter-spacing: 2px; color: #555; margin-bottom: 4px; }
            .certificate-title { font-size: 28px; margin: 6px 0 20px; color: #333; letter-spacing: 2px; }
            .body-text { font-size: 15px; line-height: 1.5; margin: 14px 30px; }
            .message-text { font-size: 13px; line-height: 1.5; margin: 10px 30px; font-style: italic; white-space: pre-line; }
            .student-name { font-size: 22px; font-weight: bold; margin: 12px 0; }
            .footer { margin-top: 60px; display: flex; justify-content: space-between; padding: 0 20mm; }
            .signature { border-top: 1px solid #333; padding-top: 6px; width: 200px; margin: 0 auto; font-size: 13px; }
            .date-text { padding-top: 6px; width: 200px; margin: 0 auto; font-size: 13px; }
          </style>
        </head>
        <body>
          <div class="frame">
            ${schoolName ? `<div class="institution">${schoolName}</div>` : ""}
            <div class="certificate-title">${title}</div>
            <div class="body-text">Certificamos que</div>
            <div class="student-name">${studentName}</div>
            <div class="body-text">
              concluiu com sucesso as atividades da turma <b>${roomName}</b>.
            </div>
            ${message ? `<div class="message-text">${message}</div>` : ""}
            <div class="footer">
              <div class="signature">${issuerName}</div>
              <div class="date-text">${issuedDate}</div>
            </div>
          </div>
        </body>
      </html>
    `);

    setTimeout(() => {
      myWindow.document.close();
      myWindow.focus();
      myWindow.print();
      myWindow.close();
    }, 250);
  }

  render() {
    if (this.state.loading) {
      return <Loading top="45" left="50" />;
    }

    return (
      <>
        <CCard>
          <CCardHeader>Emitir certificado</CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md={6}>
                <CFormGroup>
                  <CLabel>Tipo</CLabel>
                  <CSelect
                    value={this.state.type}
                    onChange={e => this.setState({ type: e.target.value })}
                  >
                    <option value="">Selecione o tipo</option>
                    {TYPE_OPTIONS.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </CSelect>
                </CFormGroup>
                {this.state.type === OTHER_TYPE && (
                  <CFormGroup>
                    <CInput
                      type="text"
                      placeholder="Digite o título do certificado"
                      value={this.state.customTitle}
                      onChange={e =>
                        this.setState({ customTitle: e.target.value })
                      }
                    />
                  </CFormGroup>
                )}
              </CCol>
              <CCol md={6}>
                <CFormGroup>
                  <CLabel>Aluno</CLabel>
                  <CSelect
                    value={this.state.studentUserId}
                    onChange={e =>
                      this.setState({ studentUserId: e.target.value })
                    }
                  >
                    <option value="">Selecione o aluno</option>
                    {this.state.students.map(student => (
                      <option key={student.user_id} value={student.user_id}>
                        {student.user_name}
                      </option>
                    ))}
                  </CSelect>
                </CFormGroup>
              </CCol>
            </CRow>
            <CFormGroup>
              <CLabel>Mensagem (opcional)</CLabel>
              <CTextarea
                rows={3}
                placeholder="Adicione uma mensagem personalizada para este certificado"
                value={this.state.message}
                onChange={e => this.setState({ message: e.target.value })}
              />
            </CFormGroup>
            <div className="d-flex justify-content-end">
              <CButton
                color="primary"
                disabled={!this.canIssue()}
                onClick={this.handleIssue}
              >
                <i className="fa fa-print mr-2"></i>Imprimir
              </CButton>
            </div>
          </CCardBody>
        </CCard>
        <CCard>
          <CCardHeader>Certificados emitidos</CCardHeader>
          <CCardBody>
            {this.state.certificates.length === 0 ? (
              <div className="text-muted">
                Nenhum certificado emitido para esta turma ainda.
              </div>
            ) : (
              <table className="table certificates-table">
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>Título</th>
                    <th>Aluno</th>
                    <th>Professor</th>
                    <th>Data</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.certificates.map(certificate => (
                    <tr key={certificate.id}>
                      <td data-label="Tipo">{certificate.type_label}</td>
                      <td data-label="Título">{certificate.title}</td>
                      <td data-label="Aluno">{certificate.student_name}</td>
                      <td data-label="Professor">{certificate.issuer_name}</td>
                      <td data-label="Data">
                        {new Date(certificate.issued_at).toLocaleDateString(
                          "pt-br"
                        )}
                      </td>
                      <td className="certificates-table-action">
                        <CButton
                          size="sm"
                          color="secondary"
                          onClick={() => this.printCertificate(certificate)}
                        >
                          Reimprimir
                        </CButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </CCardBody>
        </CCard>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(CommunityContentCertificates);
